import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.initializeSelect2();
    this.setupInfiniteScroll();
  }

  initializeSelect2() { 
    const auditGroupSelect = document.getElementById('audit-group-select');
    const actionSelect = document.getElementById('action-select');
      
    if (typeof window.jQuery !== 'undefined' && window.jQuery.fn.select2)
    {
      const $select = window.jQuery(auditGroupSelect);
      const $actionSelect = window.jQuery(actionSelect);


      this.select2Multi($actionSelect, "Select actions...");
      this.select2Multi($select, "Select audit types...");
    }
    else
    {
      // If jQuery/Select2 not ready yet, try again after a short delay
      setTimeout(() => this.initializeSelect2(), 100);
    }
  }

  select2Multi(selectElement, placeholder) {
    // If Select2 is already initialized, destroy it first to avoid conflicts
    if (selectElement.data('select2'))
      {
        selectElement.select2('destroy');
      }

      selectElement.select2({
        width: '100%',
        placeholder: placeholder,
        allowClear: true,
        closeOnSelect: false
      }).on('change', function() {
        // Change handler if needed
      });
  }

  toggleFilter() {
    const filterForm = document.getElementById('filter-form');
    filterForm.classList.toggle("d-none");
  }

  fetchMoreAudits() {
    const loadMoreAudits = document.getElementById('load-more-audits');
    if (!loadMoreAudits) return;
    
    const nextPage = loadMoreAudits.getAttribute('data-next-page');
    const path = loadMoreAudits.getAttribute('data-path');
    const filter_audits_params = JSON.parse(loadMoreAudits.getAttribute('data-params'));

    const url = new URL(path, window.location.href)
    url.searchParams.set("page", String(nextPage))
    let params = { "filter_audits": {} }
    Object.entries(filter_audits_params).forEach(([key, value]) => {
      if (value == null || value === "") return
      const name = `filter_audits[${key}]`
      if (Array.isArray(value)) {
        value.filter(Boolean).forEach((v) => url.searchParams.append(`${name}[]`, String(v)))
      } else {
        url.searchParams.append(name, String(value))
      }
    })

    console.log('url: ', url.toString());

    fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
    })
    .then(response => response.json())
      .then(data => {
      document.getElementById('audits-table-body').innerHTML += data.audits_html;

      if (data.next_page !== null) {
        this.resetObserver(data.next_page, path, filter_audits_params);
        this.setupInfiniteScroll();
      }
      else { 
        this.removeObserver();
      }
    });
  }

  removeObserver() { 
    const oldObserver = document.getElementById('load-more-audits');
    if (oldObserver) {
      oldObserver.remove();
    }
  }

  resetObserver(nextPage, path, params) {
    this.removeObserver();
    const newObserver = document.createElement('div');
    newObserver.id = 'load-more-audits';
    newObserver.dataset.nextPage = nextPage;
    newObserver.dataset.path = path;
    newObserver.dataset.params = JSON.stringify(params);
    document.getElementById('audits-card-body').appendChild(newObserver);
  }

  setupInfiniteScroll() {
    const sentinel = document.getElementById('load-more-audits');
    if (!sentinel) return;

    // Use Intersection Observer for better performance
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.fetchMoreAudits();
        }
      });
    }, {
      root: null,
      rootMargin: '100px', // Start loading 100px before reaching the bottom
      threshold: 0.1
    });
    observer.observe(sentinel);
  }

  showAudit(event) { 
    const row = event.target.closest('tr');
    const payload = JSON.parse(row.dataset.payload);

    const auditBody = `
    <ul class="list-unstyled">
      <li><strong>ID:</strong> ${payload.id}</li>
      <li><strong>Auditable Type:</strong> ${payload.auditable_type}</li>
      <li><strong>Associated Type:</strong> ${payload.associated_type}</li>
      <li><strong>Auditable ID:</strong> ${payload.auditable_id}</li>
      <li><strong>Associated ID:</strong> ${payload.associated_id}</li>
      <li><strong>User ID:</strong> ${payload.user_id}</li>
      <li><strong>User Email:</strong> ${payload.user_email}</li>
      <li><strong>Action:</strong> ${payload.action}</li>
      <li><strong>Audited Changes:</strong> ${JSON.stringify(payload.audited_changes)}</li>
      <li><strong>Comment:</strong> ${payload.comment}</li>
      <li><strong>Remote Address:</strong> ${payload.remote_address}</li>
      <li><strong>Request UUID:</strong> ${payload.request_uuid}</li>
      <li><strong>Created At:</strong> ${new Date(payload.created_at).toLocaleString("en-US", { timeZone: "America/Phoenix" })}</li>
    </ul>
    `;
    document.getElementById('auditDetailBody').innerHTML = auditBody;
    window.jQuery("#auditDetailModal").modal("show");
  }
}